// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1-v59","vizContainer":"vizContainer__1oTcF","circleWrapper":"circleWrapper__3ff_6","circle":"circle__3-NqO","vizParagraph":"vizParagraph__1jM6v","hidden":"hidden__3ljvp","whiteBlue":"whiteBlue__3wFEj","blueWhite":"blueWhite__3QAU5"};


//////////////////
// WEBPACK FOOTER
// ./components/AreaComparison/style.css
// module id = cs8j
// module chunks = 0